import React from 'react';
import { Grid, IconButton, Typography } from '@material-ui/core';
import styled from 'styled-components';
import { RefreshOutline } from '@styled-icons/evaicons-outline';

const RetryIcon = styled(RefreshOutline)`
  width: 2.5rem;
  height: 2.5rem;
  color: blue;
`;

function TableError({ handleRetry }) {
  return (
    <Grid
      item
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      xs={12}
      spacing={5}
    >
      <Grid item>
        <Typography variant="h5">
          Ha ocurrido un error intente nuevamente
        </Typography>
      </Grid>
      <Grid item>
        <IconButton onClick={handleRetry}>
          <RetryIcon />
        </IconButton>
      </Grid>
    </Grid>
  );
}

export default TableError;
